import { defineStore } from 'pinia';
import type { flightFormatItem, airportItem, segments } from '@/model/baseModel';
import myStorage from '@/utils/storage';

export const store = defineStore('store', {
  state: () => {
    const segmentInfo: segments = {
      carrier: '',
      flightNumber: '',
      depAirport: '',
      arrAirport: '',
      depTime: '',
      arrTime: '',
      aircraftCode: '',
      stopCities: '',
      codeShare: false,
      departureTerminal: '',
      arrivingTerminal: '',
      operatingFlightNo: '',
      cabin: '',
      seatCount: '',
      cabinClass: '',
      duration: '',
      fareBasis: '',
      gdsType: '',
      posArea: '',
      operatingCarrier: '',
      stopTimes: '',
      stayTime: ''
    };
    const cityInfo: airportItem = {
      airportCode: '',
      airportNameCn: '',
      airportNameEn: '',
      airportNameHk: '',
      airportNamePy: '',
      areaCode: '',
      areaName: '',
      cityCode: '',
      cityNameCn: '',
      cityNameEn: '',
      cityNameHk: '',
      cityNamePy: '',
      continentCode: '',
      continentNameCn: '',
      continentNameEn: '',
      continentNameHk: '',
      countryCode: '',
      countryNameCn: '',
      countryNameEn: '',
      countryNameHk: '',
      isCity: 0,
      isDefault: ''
    };
    const currentFlight: flightFormatItem = {
      adultPrice: 0,
      adultTax: 0,
      adultTaxType: 0,
      applyType: 0,
      infantPrice: 0,
      infantTax: 0,
      studentPrice: 0,
      studentTax: 0,
      seamanPrice: 0,
      seamanTax: 0,
      laborPrice: 0,
      laborTax: 0,
      arrCityInfo: cityInfo,
      arrDate: '',
      arrTime: '',
      carriers: [],
      childPrice: 0,
      childTax: 0,
      childTaxType: 0,
      depCityInfo: cityInfo,
      depDate: '',
      depTime: '',
      duration: 0,
      durationFrom: 0,
      durationRet: 0,
      data: '',
      fromDayPlus: 0,
      fromSegments: [segmentInfo],
      isTransit: cityInfo,
      isTransitTime: '',
      minFittableNum: 0,
      maxFittableNum: 0,
      nationality: '',
      priceType: 0,
      nationalityType: 0,
      retArrCityInfo: cityInfo,
      retArrDate: '',
      retArrTime: '',
      retDayPlus: false,
      retDepCityInfo: cityInfo,
      retDepDate: '',
      retDepTime: '',
      retSegments: [segmentInfo],
      // isTransit: cityInfo,
      carriersFrom: [],
      carriersRet: [],
      // isTransitTime: '',
      rule: {
        hasRefund: 0,
        refundCurrency: '',
        refund: '',
        refundTax: '',
        partRefund: 0,
        partRefundCurrency: '',
        partRefundPrice: '',
        partRefundTax: '',
        partRefundSeg: '',
        hasEndorse: 0,
        endorseCurrency: '',
        endorse: '',
        partEndorse: 0,
        partEndorseCurrency: '',
        partEndorsePrice: '',
        endorsement: 0,
        hasBaggage: 0,
        baggage: '',
        hasNoShow: 0,
        noShowCurrency: '',
        noShowLimitTime: 0,
        penalty: '',
        specialNoShow: 0,
        other: ''
      },
      showDuration: '',
      showFromDuration: '',
      showPrice: 0,
      showRetDuration: '',
      stops: 0,
      suitAge: '',
      ticketInvoiceType: 0,
      ticket_airline: ''
    };
    return {
      showSpin: false,
      showLoading: false,
      channelCid: myStorage.getStore('cid') || '',
      lang: myStorage.getStore('lang') || 'En',
      homeType: 1,
      payUrl: '',
      queryParam: myStorage.getStore('queryParam') || {
        toCityInfo: {
          cityCode: "",
          cityNameCn: "",
          cityNameEn: "",
          cityNameHk: "",
          cityNameId: "",
          countryCode: "",
          countryNameCn: "",
          countryNameEn: "",
          countryNameHk: "",
          countryNameId: ""
        },
        fromCityInfo: {
          cityCode: "",
          cityNameCn: "",
          cityNameEn: "",
          cityNameHk: "",
          cityNameId: "",
          countryCode: "",
          countryNameCn: "",
          countryNameEn: "",
          countryNameHk: "",
          countryNameId: ""
        },
      },
      content: myStorage.getStore('globalContent') || {
        aboutUs: {
          html: '',
          url: '',
          name: ''
        },
        bg1: '',
        customProdList: [],
        festival: [],
        hotCity: [],
        hotTicket: [],
        hotelLink: '',
        logo: '',
        pageFooter: '',
        suggestRoute: [],
        telephone: '',
        email: '',
        workTime: '',
        terms: '',
      },
      fromKeyWordsStr: myStorage.getStore('fromKeyWordsStr'),
      toKeyWordsStr: myStorage.getStore('toKeyWordsStr'),
      isLogin: myStorage.getStore('isLogin') || false,
      theme: myStorage.getStore('theme') || '',
      token: myStorage.getStore('token'),
      userInfo: myStorage.getStore('userInfo'),
      passengerList: myStorage.getStore('passengerList') || [],
      contactInfo: myStorage.getStore('contactInfo') || {
        mobile: '',
        mobileCountry: '',
        email: ''
      },
      aesCryptoStr: myStorage.getStore('aesCryptoStr'),
      currency: myStorage.getStore('currency'),
      currencyList: myStorage.getStore('currencyList'),
      priceCheckData: myStorage.getStore('priceCheckData') || {},
      succeedOrderNo: myStorage.getStore('succeedOrderNo') || '',
      cityListAirport: [],
      airportListArr: [],
      cityListObj: myStorage.getStore('cityList') || null,
      countryList: myStorage.getStore('countryList') || [],
      carrierObj: myStorage.getStore('carrierObj') || null,
      carrierList: myStorage.getStore('carrierList') || [],
      flightList: [],
      channelTradeNo: myStorage.getStore('channelTradeNo'),
      currentFlight: myStorage.getStore('currentFlight') || currentFlight,
      orderId: myStorage.getStore('orderId') as string,
      condition: myStorage.getStore('condition') || {
        count: 1,
        adultNum: 1,
        cabinGrade: 'E',
        childNum: 0,
        fromCity: {
          cityCode: '',
          cityName: ''
        },
        fromCityType: 1,
        fromDate: '',
        helperNum: 0,
        infantNum: 0,
        retDate: '',
        seamenNum: 0,
        studentNum: 0,
        ticketType: 1,
        toCity: {
          cityCode: '',
          cityName: '',
        },
        toCityType: 1,
        tripType: 1,
      }
    };
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getAirportListArr(state) {
      return state.airportListArr;
    },
    getCityListObj(state) {
      return state.cityListObj;
    },
    getCityListAirport(state) {
      return state.cityListAirport;
    },
    getUserInfo(): any {
      return this.userInfo;
    },
    getCarrierAll(state) {
      return state.carrierList;
    },
    getCondition(state) {
      return state.condition;
    },
    getCurrentFlight(state) {
      return state.currentFlight;
    },
    getCountryList(): any {
      return this.countryList;
    },
    getPassengerList(state) {
      return state.passengerList;
    },
    getContactInfo(state) {
      return state.contactInfo;
    },
    getFlightList(state) {
      return state.flightList;
    },
    getPriceCheckData(): any {
      return this.priceCheckData;
    },
    getOrderNo(state) {
      return state.succeedOrderNo;
    },
    getContent(state) {
      return state.content;
    },
    getCurrency(state) {
      return state.currency;
    },
    getCurrencyList(state) {
      return state.currencyList;
    },
    getHomeType(state) {
      return state.homeType;
    },
    getLang(): string {
      return this.lang;
    },
    getTheme(state) {
      return state.theme;
    },
    getIsLogin(state) {
      return state.isLogin;
    },
    getCarrierObj(state) {
      return state.carrierObj;
    },
    getChannelCid(): string {
      return this.channelCid;
    },
    getPayUrl(): string {
      return this.payUrl;
    },
    getFromKeyWordsStr(): string {
      return this.fromKeyWordsStr;
    },
    getToKeyWordsStr(): string {
      return this.toKeyWordsStr;
    },
    getQueryParam(): any {
      return this.queryParam;
    },
    getOrderId(): string {
      return this.orderId;
    },
    getAesCryptoStr(): string {
      return this.aesCryptoStr;
    },
    getChannelTradeNo(state) {
      return state.channelTradeNo;
    }
  },
  actions: {
    setCondition(condition: any) {
      this.condition = condition;
      myStorage.setStore('condition', condition);
    },
    setIsLogin(isLogin: boolean) {
      this.isLogin = isLogin;
      myStorage.setStore('isLogin', isLogin);
    },
    setToken(tokenStr: string) {
      this.token = tokenStr;
      myStorage.setStore('token', tokenStr);
    },
    setTheme(themeStr: any) {
      this.theme = themeStr;
      myStorage.setStore('theme', themeStr);
    },
    setUserInfo(userInfo: Object | null) {
      this.userInfo = userInfo;
      myStorage.setStore('userInfo', userInfo);
    },
    setCityListAirport(list: any) {
      this.cityListAirport = list;
    },
    setAirportListArr(list: any) {
      this.airportListArr = list;
    },
    setCityListObj(list: any) {
      this.cityListObj = list;
      myStorage.setStore('cityList', list);
    },
    setCarrierList(list: any) {
      this.carrierList = list;
      myStorage.setStore('carrierList', list);
    },
    setCarrierObj(carrierObj: Object) {
      this.carrierObj = carrierObj;
      myStorage.setStore('carrierObj', carrierObj);
    },
    setCurrentFlight(flight: any) {
      this.currentFlight = flight;
      myStorage.setStore('currentFlight', flight);
    },
    setCountryList(country: any) {
      myStorage.setStore('countryList', country);
      this.countryList = country;
    },
    setPassengerList(list: any) {
      this.passengerList = list;
      myStorage.setStore('passengerList', list);
    },
    setContactInfo(list: any) {
      this.contactInfo = list;
      myStorage.setStore('contactInfo', list);
    },
    setFlightList(list: any) {
      this.flightList = list;
    },
    setPriceCheckData(item: any) {
      let priceCheckDataItem = {
        ...item,
        routing: {
          ...item.routing,
          payAdultPrice: item.routing.payAdultPrice ? item.routing.payAdultPrice : '0.00',
          payChildPrice: item.routing.payChildPrice ? item.routing.payChildPrice : '0.00',
          payInfantPrice: item.routing.payInfantPrice ? item.routing.payInfantPrice : '0.00',
          technicalServiceFee: item.routing.technicalServiceFee ? item.routing.technicalServiceFee : 0,
          platformFee: item.routing.platformFee ? item.routing.platformFee : 0
        }
      };
      this.priceCheckData = priceCheckDataItem;
      myStorage.setStore('priceCheckData', priceCheckDataItem);
    },
    setOrderNo(orderNo: any) {
      this.succeedOrderNo = orderNo;
      myStorage.setStore('succeedOrderNo', orderNo);
    },
    setContent(content: any) {
      this.content = content;
      myStorage.setStore('globalContent', content);
    },
    setCurrency(currency: string) {
      this.currency = currency;
      myStorage.setStore('currency', currency);
    },
    setCurrencyList(currencyList: string[]) {
      this.currencyList = currencyList;
      myStorage.setStore('currencyList', currencyList);
    },
    setHomeType(type: any) {
      this.homeType = type;
    },
    setLang(lang: string) {
      this.lang = lang;
      myStorage.setStore('lang', lang);
    },
    setSpin(lang: boolean) {
      this.showSpin = lang;
    },
    setShowLoaing(loadBool: boolean) {
      this.showLoading = loadBool;
    },
    setChannelCid(channelCid: string) {
      this.channelCid = channelCid;
      myStorage.setStore('cid', channelCid);
    },
    setPayUrl(payUrl: string) {
      this.payUrl = payUrl;
    },
    setFromKeyWordsStr(fromKeyWordsStr: string) {
      myStorage.setStore('fromKeyWordsStr', fromKeyWordsStr);
      this.fromKeyWordsStr = fromKeyWordsStr;
    },
    setToKeyWordsStr(toKeyWordsStr: string) {
      myStorage.setStore('toKeyWordsStr', toKeyWordsStr);
      this.toKeyWordsStr = toKeyWordsStr;
    },
    setQueryParam(queryParam: any) {
      myStorage.setStore('queryParam', queryParam);
      this.queryParam = queryParam;
    },
    setOrderId(orderId: string) {
      myStorage.setStore('orderId', orderId);
      this.orderId = orderId;
    },
    setAesCryptoStr(aesCryptoStr: string) {
      console.log(aesCryptoStr, 'aesCryptoStr');
      myStorage.setStore('aesCryptoStr', aesCryptoStr);
      this.aesCryptoStr = aesCryptoStr;
    },
    setChannelTradeNo(channelTradeNo: string) {
      myStorage.setStore('channelTradeNo', channelTradeNo);
      this.channelTradeNo = channelTradeNo;
    }
  }
});
